export const getTime = timestamp => {
  const hours = Math.floor(timestamp / 60 / 60)
  const minutes = Math.floor(timestamp / 60) - hours * 60
  const seconds = timestamp % 60
  return (
    // hours.toString().padStart(2, '0') +
    // ':' +
    minutes.toString().padStart(2, '0') +
    ':' +
    seconds.toString().padStart(2, '0')
  )
}

// https://tinyurl.com/ybmlm7ev
export const pickRandom = (arr, count) => {
  let _arr = [...arr]
  return [...Array(count)].map(
    () => _arr.splice(Math.floor(Math.random() * _arr.length), 1)[0]
  )
}

export const shuffle = a => {
  var j, x, i
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1))
    x = a[i]
    a[i] = a[j]
    a[j] = x
  }
  return a
}

export const getPageName = url => {
  const parts = url.split('/')
  const position = parts[parts.length - 1] === '' ? 2 : 1
  return parts[parts.length - position]
}
